<template>
  <div class="search main_style">
    <Main_nav />
    <b-row>
      <b-col class="d-flex justify-content-start ml-2">
        <b-button
          style="background-color: white; color: #333333; border: none"
          @click="goBack"
        >
          <b-icon-arrow-left-circle></b-icon-arrow-left-circle>
          หน้าหลัก
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="d-flex justify-content-center">
        <img
          height="auto"
          src="../assets/images/logo/logo_community_biobank.svg"
          width="221px"
        />
      </b-col>
    </b-row>
    <div class="my-5">
      <searchBar />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Main_nav from "@/components/navbar";
import searchBar from "@/components/searchBar";

export default {
  name: "SearchPage",
  data() {
    return {
      text: "",
    };
  },
  components: {
    Main_nav,
    searchBar,
  },

  methods: {
    goBack() {
      const path = `/`;
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },
  },
};
</script>
<style lang="scss"></style>
